import { Injectable } from '@angular/core';
import {
  LoaderService,
  NotificationTypeEnum,
  deleteCookie,
} from '@poste-click-connect/shared-ui';
import { Router } from '@angular/router';
import { FacadeService } from './facade.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService {
  public isLottomatica: boolean = false;
  public showModalError: boolean = false;
  public isApiError: boolean = false;
  private _isLoginCambioPassword: boolean = false;

  get isLoginCambioPassword(): boolean {
    return this._isLoginCambioPassword;
  }

  set isLoginCambioPassword(value: boolean) {
    this._isLoginCambioPassword = value;
  }

  constructor(
    private loader: LoaderService,
    private facade: FacadeService,
    private router: Router
  ) {}

  start(): void {
    this.loader.show();
  }

  end(): void {
    this.loader.hide();
  }

  logout(): void {
    this.facade.addNotification({
      type: NotificationTypeEnum.WARNING,
      description:
        'La sessione è scaduta, si prega di effettuare un nuovo accesso',
    });
    this.effectiveLogout();
  }

  invalidSession(): void {
    this.facade.addNotification({
      type: NotificationTypeEnum.WARNING,
      description:
        'La sessione non è più valida, si prega di effettuare un nuovo accesso',
    });
    this.effectiveLogout(true);
  }

  effectiveLogout(softLogout: boolean = false): void {
    this.showModalError = false;
    this.facade.logout();

    if (!softLogout) {
      deleteCookie('accessToken', window.location.hostname, true);
    }

    deleteCookie('user', window.location.hostname, true);
    this.router.navigateByUrl('/login');
  }

  closeModalError(): void {
    this.showModalError = false;
    this.isApiError = false;
  }
}
